import React, { useState } from 'react';
import {
  Container,
  Col,
  Row,
  InputGroup,
  Input,
  CustomInput,
  Form,
  FormGroup,
  Label,
  FormFeedback,
  Alert
} from 'reactstrap';
import './_registration.scss';
import Toggle from 'react-toggle';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { Redirect } from 'react-router-dom';
import ApolloClient from 'apollo-client';
import AWSAppSyncClient from 'aws-appsync';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
import {
  useAppContext,
} from '../../state/GlobalState';
import {
  AdminRegistrationSchema,
  DriverRegistrationSchema,
  initialValues,
} from './validation';
import withClient from '../../hoc/withClient';
import './_registration.scss';
import pageTitleConstant from '../../analytics/constantPageTitle';
import {
  clearFieldsClickHandler,
  registerClickHandler
} from '../../analytics/events';
import NetworkSpeedChecker from '../../components/NetworkSpeedChecker/NetworkSpeedChecker';
import { postRegistration} from '../../api/graphQl/Registration';
// import { readToken } from '../../helpers/localStorage';
// import axios from 'axios';

import { carriersList } from '../../helpers/carriers';

const userDriver = 'Driver'
const userCarrierAdmin = 'Carrier Admin'

const Registration = ({
  graphClient,
}) => {
  const {
    registrationEnabled
  } = useAppContext();
  const [userType, setUserType] = useState(userDriver);
  const [driverStatus, setDriverStatus] = useState(true);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');



  if (!registrationEnabled) {
      // If there's no shipment id, redirect to find shipment page
      return <Redirect to="/shipment" />;
  }

  // const checkEmail = async (email) => {
  //   const options = {
  //     method: 'GET',
  //     url: 'https://graph.microsoft.com/v1.0/groups/05349702-e82f-4050-95de-f5503d3668f2/members',
  //     headers: {
  //       Authorization: `Bearer ${readToken()}`,
  //     }
  //   };
    
  //   try {
  //     const { data } = await axios.request(options);  
  //     console.log("data", data);
  //   } catch (error) {
  //     console.error(error);
  //   }  
  // }
  
  const onSubmit = async (values, formikBag) => {
    // await checkEmail(values.Email);
    
    const DriverId = userType === userDriver ? values.DriverId : values.Email;
    const inputValues = {
      FirstName: values.FirstName,
      LastName: values.LastName,
      Email: values.Email,
      DriverId: DriverId,
      CarrierId: values.CarrierId,
    };
    let registrationValues = await postRegistration(graphClient, inputValues);
    if(registrationValues.data && !registrationValues.error) {
      let message = 'User has been registered successfully.';
      if(registrationValues.data.LastActionType === 'UPDATE') {
        message = 'User details have been updated successfully.';
      } 
      setSuccessMessage(message);
      setErrorMessage('');
      formikBag.resetForm({ values: getInitialValues() });
    } else if(registrationValues.error){
      setErrorMessage(registrationValues.error.replace('GraphQL error: ', 'Error: '));
      setSuccessMessage('');
    } else {
      setErrorMessage('Some error occurred during registration. Please try again later or contact support.');
      setSuccessMessage('');
    }    
  };

  const getInitialValues = () => {
    const overrideValues = {};
    // Pre-select values for load id addon and product if only one value is present
    return Object.assign(initialValues, overrideValues);
  };

  const handleFormReset = (resetForm, values) => {
    resetForm({
      values: {
        ...initialValues,
      },
      errors: {}, // clear validation errors explicitly
      touched: {}, // clear touched fields
    });
    setErrorMessage('');
    setSuccessMessage('');
  };

  return (
    <Container className="registration-container pl-0 pr-0" data-testid="registration-container">
      <NetworkSpeedChecker />

      {/* <PageHeading label="Registration"/> */}

      <Container className="page-heading-container p-0" data-testid="page-heading-container">
        <Row>
          <Col>
            <h6>Registration</h6>
          </Col>
        </Row>
      </Container>
      <Row>
        <Col>
         {successMessage && <Alert variant="success">{successMessage}</Alert>}
         {errorMessage && <Alert style={{ backgroundColor: '#dc3545', color: '#fff' }}>{errorMessage}</Alert>}
        </Col>
      </Row>

      <Formik
        initialValues={getInitialValues()}
        validationSchema={userType === userDriver ? DriverRegistrationSchema : AdminRegistrationSchema  }
        validateOnMount
        onSubmit={(values, formikBag) => onSubmit(values, formikBag)}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          isSubmitting,
          isValid,
          values,
          errors,
          touched,
          dirty,
          resetForm,
          setFieldValue,
        }) => (
          <Form noValidate onSubmit={handleSubmit} data-testid="registration-form">
            <Row className="mt-3 mb-6">
              <Toggle
                data-testid="carrier-admin-toggle"
                aria-labelledby="biscuit-label"
                defaultChecked={false}
                onChange={() => {
                  setUserType(userType === userDriver ? userCarrierAdmin : userDriver);
                  setDriverStatus(!driverStatus);
                  handleFormReset(resetForm, values);
                }}
                icons={false}
                className='ml-4'
              />              
              {/* This will change the label text for dynamic behavior */}
              <Label className="toggle-heading ml-3 font-14">Register as {userType === userCarrierAdmin ? userCarrierAdmin : userDriver}</Label>
            </Row>
            <Row>
              {/* Field: First Name */}
              <Col xs="12" md="6">
                <FormGroup className="mb-10">
                  <Label for="FirstName">
                    First Name <span className="text-danger">* </span>
                  </Label>
                  <InputGroup className="input-colour">
                    <Input
                      type="text"
                      name="FirstName"
                      data-testid="FirstName-field"
                      value={values.FirstName}
                      invalid={!!errors.FirstName && touched.FirstName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      maxLength={10}
                    />
                    <FormFeedback type="invalid" data-testid="FirstName-feedback">{errors.FirstName}</FormFeedback>
                  </InputGroup>
                </FormGroup>
              </Col>

              
              {/* Field: First Name */}
              <Col xs="12" md="6">
                <FormGroup className="mb-10">
                  <Label for="LastName">
                    Last Name 
                  </Label>
                  <InputGroup className="input-colour">
                    <Input
                      type="text"
                      name="LastName"
                      data-testid="LastName-field"
                      value={values.LastName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      invalid={!!errors.LastName && touched.LastName}
                      maxLength={10}
                    />                    
                    <FormFeedback type="invalid" data-testid="LastName-feedback">{errors.LastName}</FormFeedback>
                  </InputGroup>
                </FormGroup>
              </Col>

              {/* Field: Email */}
              <Col xs="12" md="6">
                <FormGroup className="mb-10">
                  <Label for="Email">
                    Email <span className="text-danger">* </span>
                  </Label>
                  <InputGroup className="input-colour">
                    <Input
                      type="email"
                      name="Email"
                      data-testid="Email-field"
                      value={values.Email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      invalid={!!errors.Email && touched.Email}
                      autoComplete="off"
                    />                    
                  <FormFeedback type="invalid" data-testid="Email-feedback">{errors.Email}</FormFeedback>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col xs="12" md="6">
              <FormGroup className="mb-10 mb-md-8">
                <Label for="CarrierId">
                  Carrier Id <span className="text-danger">* </span>
                </Label>
                <InputGroup>
                  <CustomInput
                    type="select"
                    name="CarrierId"
                    id="CarrierId-select"
                    data-testid="CarrierId-select"
                    value={values.CarrierId}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    invalid={Boolean(errors.CarrierId) && touched.CarrierId}
                    bsSize="lg"
                    className="input-colour"
                  >
                    <option key="" value="" hidden>Select an option...</option>
                    {
                      carriersList.map(
                        (carrier) => (
                          <option
                            key={carrier.id}
                            value={carrier.id}
                            data-testid={`CarrierId-option-${carrier.id}`}
                          >
                            {carrier.id} - {carrier.name}
                          </option>
                        ),
                      )
                    }
                  </CustomInput>
                  <FormFeedback type="invalid" data-testid="CarrierId-feedback">{errors.CarrierId}</FormFeedback>
                </InputGroup>
              </FormGroup>
              </Col>
              {driverStatus && (
                 /* Field: DriverId */
                <Col xs="12" md="6">
                  <FormGroup className="mb-10">
                    <Label for="DriverId">
                      Driver Id <span className="text-danger">* </span>
                    </Label>
                    <InputGroup className="input-colour">
                      <Input
                        type="text"
                        name="DriverId"
                        data-testid="DriverId-field"
                        value={values.DriverId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!errors.DriverId && touched.DriverId}
                        autoComplete="off"
                        maxLength={20}
                      />
                      <FormFeedback type="invalid" data-testid="DriverId-feedback">{errors.DriverId}</FormFeedback>
                    </InputGroup>
                  </FormGroup>
                </Col>
              )}
            </Row>
            <Row>
              <Col xs="12">
                <PrimaryButton
                  disabled={isSubmitting || !isValid || !dirty}
                  className="submit-button"
                  data-testid="register-button"
                  type="Submit"
                  label="Register"
                  tabIndex={0}
                  onClick={() => registerClickHandler(pageTitleConstant.registrationForm)}
                />
              </Col>
              <Col xs="12" className="mt-6">
                <div
                  className="green-link"
                  data-testid="clear-all-link"
                  onClick={() => {
                    handleFormReset(resetForm, values);
                    clearFieldsClickHandler(pageTitleConstant.registrationForm);
                  }}
                  role="button"
                >
                  Clear all fields
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};

/**
 * We use oneOfType because
 * the application uses AppSyncClient
 * the tests/jest provide ApolloClient as we use the <MockProvider/>
 */
Registration.propTypes = {
  graphClient: PropTypes.oneOfType([
    PropTypes.instanceOf(AWSAppSyncClient).isRequired,
    PropTypes.instanceOf(ApolloClient).isRequired,
  ]).isRequired,
};

// withClient will provide the client in props
export default withClient(Registration);
